module.exports = __webpack_public_path__ + "static/media/icn-coat.92aff8d3.svg";